import React from 'react';
import { SectionWrapper } from './SectionWrapper';
export const Author: React.FC = () => {
  return <SectionWrapper data-id="element-16">
      <div className="bg-navy-light rounded-2xl p-8 md:p-12 shadow-xl border border-gray-800" data-id="element-17">
        <div className="flex flex-col md:flex-row items-center md:items-start gap-8 md:gap-12" data-id="element-18">
          <div className="shrink-0" data-id="element-19">
            <div className="w-40 h-40 md:w-48 md:h-48 rounded-full border-4 border-gold overflow-hidden shadow-lg" data-id="element-20">
              <img src="https://cdn.magicpatterns.com/uploads/7zEYKow1yVny9xVTQr9rTK/perfil_profesional_edisson.jpg" alt="Edison Ricardo Ramírez" className="w-full h-full object-cover" data-id="element-21" />
            </div>
          </div>

          <div className="flex-1 text-center md:text-left" data-id="element-22">
            <h2 className="text-3xl md:text-4xl font-bold text-gold mb-2" data-id="element-23">
              Edison Ricardo Ramírez
            </h2>
            <p className="text-lg text-gray-300 font-medium mb-6" data-id="element-24">
              Creador del Método MRA · Especialista en Comunicación Estratégica
              para Entrevistas Consulares
            </p>
            <div className="space-y-4 text-lg text-white leading-relaxed" data-id="element-25">
              <p data-id="element-26">
                Edison desarrolló el Protocolo Visa Master después de analizar
                los patrones exactos de respuesta que generan aprobaciones
                rápidas — y los errores silenciosos que generan rechazos.
              </p>
              <p data-id="element-27">
                Este sistema está diseñado para que cualquier solicitante, sin
                importar su nivel de ingresos o estado civil, entre a la
                embajada con claridad y salga con su Visa.
              </p>
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>;
};